import { normalizeCollectionResponse, normalizeRecordResponse, notificationParams } from 'api';
import { client, computeHeaders } from 'queries';

export const notificationQuery = async ({ req, params }) => {
	const formattedParams = { context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/notifications/${params.notificationId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const notificationsQuery = async ({ req, params }) => {
	const formattedParams = { ...notificationParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/notifications`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
